import React from 'react'
import { Link } from 'react-router-dom'

import logo from '../assets/images/logo-light.png'

export default function Footer() {
  return (
        <footer className="py-8 bg-slate-800 dark:bg-slate-900">
            <div className="container">
                <div className="grid md:grid-cols-10 items-center">
                    <div className="md:col-span-2">
                        <Link to="#" className="logo-footer">
                            <img src={logo} className="md:ms-0 mx-auto" alt=""/>
                        </Link>
                    </div>

                    <div className="md:col-span-7 md:mt-0 mt-8">
                        <div className="text-center">
                            <p className="text-sm font-normal leading-relaxed text-gray-400">
                            © {new Date().getFullYear()} &nbsp; Visita nuestras &nbsp;{ "  "}
                            <Link
                                to="/politicas-privacidad"
                                className="font-medium text-gray-100 underline decoration-red-500/40 underline-offset-4 transition-colors duration-300 hover:text-red-400 hover:decoration-red-400">
                                       Políticas de Privacidad &nbsp;</Link>{" "}y{" "}<Link
                                to="/terminos-condiciones"
                                className="font-medium text-gray-100 underline decoration-red-500/40 underline-offset-4 transition-colors duration-300 hover:text-red-400 hover:decoration-red-400">
                                 &nbsp;Términos y Condiciones
                            </Link>.
                            </p>                        
                            </div>
                    </div>
                </div>
            </div>
        </footer>
  )
}
